<template>
    <div class="header">
        <div class="header_pad flex a-c j-a">
            <div class="headerp_left flex a-c">
                <span ><span v-if="userInfo !== ''">您好</span>{{ device !== 'mobile' ? '您好，欢迎您来到江南药镇' : '' }}</span>
                <div v-if="userInfo === ''">
                    <a @click="toLogin()">请登录</a>
                    <a @click="toReg()" class="headerpr_d1">注册</a>
                </div>
                <div v-else class="flex">
                    <a @click="toMy()">{{ userInfo.RealName || userInfo.Nick }}&nbsp;&nbsp;&nbsp;&nbsp;</a>
                    <a @click="logout" v-if="device !== 'mobile'">退出</a>
                </div>
            </div>
            <div class="headerp_right" >
                <div v-if="device !== 'mobile'">
                    <a>
                        <img src="./imgs/手机.png"/>&nbsp; 二维码
                    </a>
                    <a @click="toOrderList()" class="headerpr_d2">我的订单</a>
                    <a @click="toCar()" >
                       <img src="./imgs/购物车空.png"> &nbsp;购物车
                    </a>
                    <!-- <a @click="toHelp()">帮助中心</a> -->
                </div>
                <div v-else>
                    <el-dropdown v-if="userInfo !== ''"  trigger="click" >
                        <span class="el-dropdown-link">
                            我的
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="toOrderList()">我的订单</el-dropdown-item>
                            <el-dropdown-item @click.native="toCar()">购物车</el-dropdown-item>
                            <el-dropdown-item @click.native="logout()">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex"
import { toLogin } from "@/utils"
export default {
    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters(["device","userInfo","userId"])
    },
    watch: {

    },
    created: function () {
    },
    mounted: function () {
        
    },
    methods: {
        ...mapActions("user",["logout"]),
        toLogin() {
           toLogin(this)
        },
        toReg() {
            this.$router.push("/reg")
        },

        toOrderList() {
            if (this.userId == "") {
                toLogin(this)
                this.$message.error("请先登录后查看");
            } else {
                this.$router.push("/orderList")
            }
        },
        toMy() {
            if (this.userId == "") {
                toLogin(this)
                this.$message.error("请先登录后查看");
            } else {
                this.$router.push("/userInfo")
            }
        },
        toExit() {
            toLogin(this)
            this.$message.error("退出成功");
        },
        toCar() {
            console.log(111);
            if (this.userId == "") {
                toLogin(this)
                this.$message.error("请先登录后查看");
            } else {
                this.$router.push("/car")
            }
        },
        toHelp() {
            this.$router.push("/help")
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    width: 100%;
    height: 40px;
    background-color: #f1f1f1;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
}

.header_pad {
    margin: 0 auto;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
}

.headerp_left a {
    float: left;
    padding: 0 12px;
    color: #302e2e;
}

.headerp_right img {
    vertical-align: middle;
    margin-bottom: 5px;
}
.headerp_left span {
    float: left;
    margin-right:5px;
}

/* .headerp_left div {
} */

/* .headerp_left div a:nth-child(1) {
    color: #398e53;
} */

.headerp_right a {
    float: left;
    padding: 0 12px;
    color: #302e2e;
}

.headerpr_d1 {
    box-sizing: border-box;
    border-left: 1px solid #cccccc;
    height: 20px;
    margin-top: 10px;
    line-height: 20px;
}
.headerpr_d2 {
    box-sizing: border-box;
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    height: 20px;
    margin-top: 10px;
    line-height: 20px;
}

.headerpr_d2 img {
    width: 17px;
    height: 14px;
    margin-right: 8px;
}
</style>